import type { IApplicationState } from 'shared/types/redux';

export const selectCPDRegions = (state: IApplicationState) => state.cpd.cpdRegions;
